import type { FieldValues, FieldPath } from "react-hook-form";
import { FormField } from "./FormField";
import { FileAttachment } from "../ui/FileAttachment";

interface FormFileAttachmentProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> {
  name: TName;
  label?: string;
  optional?: boolean;
  acceptedTypes: string[];
  "data-testid"?: string;
}

export function FormFileAttachment<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  label,
  optional,
  acceptedTypes,
  "data-testid": dataTestId,
}: FormFileAttachmentProps<TFieldValues, TName>) {
  return (
    <FormField
      name={name}
      render={({ value, onChange, errorMessage, disabled }) => (
        <FileAttachment
          value={value ?? null}
          onChange={onChange}
          errorMessage={errorMessage}
          label={label}
          optional={optional}
          acceptedTypes={acceptedTypes}
          disabled={disabled}
          data-testid={dataTestId}
        />
      )}
    />
  );
}
